import googleService from './GoogleService';

async function filterResultsWithGooglePlaceIds(value, dataset, options) {
    let googleOptions = [];
    let googlePlaceIds = [];
    try {
        const googlePredictions = await googleService.getPlacePredictionsForRegions(value, options);
        googlePlaceIds = googlePredictions.reduce((arr, prediction) => {
            return [...arr, prediction.placeId];
        }, []);

        googleOptions = filterGooglePredictions(googlePredictions, googlePlaceIds, dataset);
    } catch (ex) {
        // move along little doggie
    }

    const filteredOptions = dataset
        .filter((option) => {
            if (googlePlaceIds.includes(option.placeId)) {
                return false;
            }

            const textMatch = option.text.toLowerCase().includes(value);
            const idMatch = option.id.toLowerCase() === value;
            return textMatch || idMatch;
        });

    return [...googleOptions, ...filteredOptions];
}

function filterGooglePredictions(googlePredictions, googlePlaceIds, dataset) {
    return dataset
        .filter((country) => googlePlaceIds.includes(country.placeId))
        .sort((optionA, optionB) => {
            const googlePredictionA = googlePredictions.find((prediction) => {
                return prediction.placeId === optionA.placeId;
            });

            const googlePredictionB = googlePredictions.find((prediction) => {
                return prediction.placeId === optionB.placeId;
            });

            if (googlePredictionA.text.length < googlePredictionB.text.length) {
                return -1;
            }

            if (googlePredictionA.text.length > googlePredictionB.text.length) {
                return 1;
            }

            return googlePredictionA.text < googlePredictionB.text
                ? -1
                : 1;
        });
}

export {
    filterResultsWithGooglePlaceIds,
};
